import { useEffect } from "react";
import { useUiStore } from "@/application/stores/uiStore";
import { playBgm, stopBgm } from "@/infrastructure/assets/audio";
import type { BgmName } from "@/infrastructure/assets/paths";

/**
 * 画面に応じた囃子を鳴らす。ミュート中は`playBgm`が音源を取得しない（NFR-003）。
 * `name === null` のときはこのフックは囃子を制御しない（子の AdvScene 等に委ねる）。
 *
 * 再生・停止はどちらも`setTimeout(0)`で次タスクへ逃がす。
 * 画面遷移のクリック→描画（NFR-001）の同期経路を Audio I/O で塞がないため
 * （打ち音・師範代ボイスと同じ教訓。ui-design / NFR-002）。
 */
export function useBgm(name: BgmName | null): void {
  const muted = useUiStore((state) => state.muted);
  const volume = useUiStore((state) => state.volume);

  useEffect(() => {
    if (name === null) {
      return undefined;
    }
    if (muted) {
      const stopTimer = window.setTimeout(() => stopBgm(), 0);
      return () => window.clearTimeout(stopTimer);
    }
    const playTimer = window.setTimeout(() => {
      playBgm(name, false, volume);
    }, 0);
    return () => {
      window.clearTimeout(playTimer);
      window.setTimeout(() => stopBgm(), 0);
    };
  }, [name, muted, volume]);
}
